import { ApiResult, HttpClient } from "../http.js";
import {
  CommunicationEntityType,
  CommunicationMessageDto,
  CommunicationVisibility,
  NotifyTarget,
} from "../types/communication-messages.js";

export interface ListCommunicationMessagesQuery {
  entityType: CommunicationEntityType;
  entityId: string;
}

export interface CreateCommunicationMessagePayload {
  entityType: CommunicationEntityType;
  entityId: string;
  content: string;
  visibility?: CommunicationVisibility;
  notifyTarget?: NotifyTarget;
}

export interface UpdateCommunicationMessagePayload {
  content: string;
}

export class CommunicationMessagesApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListCommunicationMessagesQuery): Promise<ApiResult<CommunicationMessageDto[]>> {
    return this.http.get<CommunicationMessageDto[]>("/api/communication-messages", { query: { ...query } });
  }

  create(payload: CreateCommunicationMessagePayload): Promise<ApiResult<CommunicationMessageDto>> {
    return this.http.post<CommunicationMessageDto>("/api/communication-messages", { body: payload });
  }

  update(id: string, payload: UpdateCommunicationMessagePayload): Promise<ApiResult<CommunicationMessageDto>> {
    return this.http.put<CommunicationMessageDto>(`/api/communication-messages/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<boolean>> {
    return this.http.delete<boolean>(`/api/communication-messages/${encodeURIComponent(id)}`);
  }
}
